module.exports = __webpack_public_path__ + "static/img/max_pictgrid4_800x506.975cdf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid4_800x506.jpg
// module id = jpFu
// module chunks = 0